import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "StoryFormSlide flex items-start" }
const _hoisted_2 = { class: "w-1/2 flex justify-center items-center" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "w-1/2 flex flex-col pl-6" }
const _hoisted_5 = { class: "flex items-center justify-between" }
const _hoisted_6 = { class: "text-lg text-gray-500" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash mr-2" }, null, -1)
const _hoisted_8 = {
  key: 0,
  class: "flex items-center justify-between mt-3"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times mr-2" }, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-check mr-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_button = _resolveComponent("the-button")!
  const _component_file_reader = _resolveComponent("file-reader")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        class: "w-80 h-96 object-contain",
        src: _ctx.state.image
      }, null, 8, _hoisted_3)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("h2", _hoisted_6, "Слайд " + _toDisplayString(_ctx.index + 1), 1),
        _createVNode(_component_the_button, {
          class: "red text small",
          onClick: _ctx.emitDelete,
          loading: _ctx.state.is_deleting
        }, {
          default: _withCtx(() => [
            _hoisted_7,
            _createTextVNode(" Удалить ")
          ]),
          _: 1
        }, 8, ["onClick", "loading"])
      ]),
      _createVNode(_component_file_reader, {
        class: "w-full mt-3",
        placeholder: "Выберите изображение слайда",
        accept: "image/*",
        value: _ctx.state.images,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.images) = $event)),
        disabled: _ctx.state.is_deleting,
        onChange: _ctx.setImage
      }, null, 8, ["value", "disabled", "onChange"]),
      (_ctx.state.images.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createVNode(_component_the_button, {
              class: "second text small",
              disabled: _ctx.state.is_saving,
              onClick: _ctx.cancel
            }, {
              default: _withCtx(() => [
                _hoisted_9,
                _createTextVNode(" Отмена ")
              ]),
              _: 1
            }, 8, ["disabled", "onClick"]),
            _createVNode(_component_the_button, {
              class: "primary text small",
              loading: _ctx.state.is_saving,
              onClick: _ctx.emitSave
            }, {
              default: _withCtx(() => [
                _hoisted_10,
                _createTextVNode(" Сохранить ")
              ]),
              _: 1
            }, 8, ["loading", "onClick"])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}